import { LoanCriteria, LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { ProductType } from '@/components/modules/Funnel/types/ProductType';
import { getProductType } from '@/components/modules/Funnel/utils/getProductType';
import { getApplicationTypeByLoanCriteria } from '@/utils/getApplicationTypeByLoanCriteria';

export const getProductCriteriaProcessStatus = (loan: LoanCriteria) => {
  const status = loan.status;
  const productType = getProductType(getApplicationTypeByLoanCriteria(loan));

  switch (productType) {
    case ProductType.LOAN:
      switch (status) {
        case LoanStatus.STATUS_ANALYSING:
          return LoanStatusExternal.REQUESTED;

        case LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED:
        case LoanStatus.STATUS_CONTRACT_SIGNED:
          return LoanStatusExternal.APPROVED;

        default:
          return status;
      }

    case ProductType.ORDER:
      switch (status) {
        case LoanStatus.STATUS_ANALYSING:
        case LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED:
          return LoanStatus.STATUS_INITIAL;

        case LoanStatus.STATUS_CONTRACT_SIGNED:
          return LoanStatusExternal.REQUESTED;

        default:
          return status;
      }

    default:
      return status;
  }
};
